import { FC } from 'react';
import { defineMessages, useIntl } from 'dibs-react-intl';

import ActionModal, { ActionModalProps } from './ActionModal';
import { DeleteDraftStatus } from '../../hooks/useDeleteDraft';
export const DELETE_DRAFT = 'DELETE_DRAFT';

export const deleteModalCopy = defineMessages({
    initialTitle: { id: 'nft.create.deleteDraft.title', defaultMessage: 'Delete Draft' },
    successTitle: { id: 'nft.create.deleteDraft.successTitle', defaultMessage: 'Draft Deleted' },
    initial: {
        id: 'nft.create.deleteDraft.body',
        defaultMessage:
            "Are you sure you'd like to delete this draft? Once deleted, drafts cannot be recovered.",
    },
    cta: { id: 'nft.create.deleteDraft.cta', defaultMessage: 'Delete Draft' },
    ctaSuccess: { id: 'nft.create.deleteDraft.ctaSuccess', defaultMessage: 'Create NFT' },
    success: {
        id: 'nft.create.deleteDraft.body.success',
        defaultMessage: 'Your draft was deleted successfully.',
    },
    secondaryCta: { id: 'nft.create.deleteDraft.secondaryCta', defaultMessage: 'Cancel' },
    secondaryCtaSuccess: {
        id: 'nft.create.deleteDraft.body.secondaryCtaSuccess',
        defaultMessage: 'Back to Profile',
    },
});

export type DeleteDraftProps = {
    onClick: () => void;
    onClose: ActionModalProps['onClose'];
    status: DeleteDraftStatus;
    nftItemDraft: ActionModalProps['nftItemDraft'];
    publicProfileUrl: string;
};

const DeleteDraftModal: FC<DeleteDraftProps> = ({
    status,
    onClick,
    nftItemDraft,
    onClose,
    publicProfileUrl,
    ...modalProps
}) => {
    const { formatMessage } = useIntl();
    const derivedCopyKey = status === 'inflight' ? 'initial' : status || 'initial';

    let ctaMessage;
    if (status === null) {
        ctaMessage = formatMessage(deleteModalCopy.cta);
    } else if (status === 'success') {
        ctaMessage = formatMessage(deleteModalCopy.ctaSuccess);
    }

    let secondaryCtaMessage;
    if (status === null) {
        secondaryCtaMessage = formatMessage(deleteModalCopy.secondaryCta);
    } else if (status === 'success') {
        secondaryCtaMessage = formatMessage(deleteModalCopy.secondaryCtaSuccess);
    }

    return (
        <ActionModal
            {...modalProps}
            status={status}
            nftItemDraft={nftItemDraft}
            onClose={onClose}
            title={formatMessage(deleteModalCopy[`${derivedCopyKey}Title`])}
            ctaOnClick={status === null ? onClick : onClose}
            cta={ctaMessage}
            secondaryCta={secondaryCtaMessage}
            secondaryCtaHref={status === 'success' ? publicProfileUrl : undefined}
            secondaryCtaOnClick={status !== 'success' ? onClose : undefined}
        >
            <p>{formatMessage(deleteModalCopy[derivedCopyKey])}</p>
        </ActionModal>
    );
};

export default DeleteDraftModal;
